import { useState, useEffect } from "react";

export const BREAKPOINTS = {
  phone: 768,   // max-width for phone (below this = phone)
  tablet: 1280, // max-width for tablet (below this = tablet, at or above = desktop)
} as const;

type Breakpoint = "phone" | "tablet" | "desktop";

function getBreakpoint(): Breakpoint {
  if (typeof window === "undefined") return "desktop";
  const w = window.innerWidth;
  if (w < BREAKPOINTS.phone) return "phone";
  if (w < BREAKPOINTS.tablet) return "tablet";
  return "desktop";
}

export function useBreakpoint() {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(getBreakpoint);

  useEffect(() => {
    const phoneQuery = window.matchMedia(`(max-width: ${BREAKPOINTS.phone - 1}px)`);
    const tabletQuery = window.matchMedia(`(min-width: ${BREAKPOINTS.phone}px) and (max-width: ${BREAKPOINTS.tablet - 1}px)`);

    const update = () => {
      if (phoneQuery.matches) setBreakpoint("phone");
      else if (tabletQuery.matches) setBreakpoint("tablet");
      else setBreakpoint("desktop");
    };

    phoneQuery.addEventListener("change", update);
    tabletQuery.addEventListener("change", update);

    return () => {
      phoneQuery.removeEventListener("change", update);
      tabletQuery.removeEventListener("change", update);
    };
  }, []);

  return {
    breakpoint,
    isPhone: breakpoint === "phone",
    isTablet: breakpoint === "tablet",
    isDesktop: breakpoint === "desktop",
  };
}
